import useFetchGroup from '@/api/hooks/useFetchGroup';
import usePageData from '@/api/hooks/usePageData';
import AccordionPanel from '@/components/AccordionItem';
import Product from '@/components/ProductCard';
import { FC, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation } from 'react-router-dom';

const ProductDetail: FC = () => {
  const [product, setProduct] = useState<any>();
  const [products, setProducts] = useState<any[]>([]);
  const [categories, setCategories] = useState<any[]>([]);
  const [accordionData, setAccordionData] = useState<any[]>([]);
  const [activePanel, setActivePanel] = useState<number | null>(null);

  const {
    data: pageData,
    localization,
    page
  } = usePageData();

  useEffect(() => {
    if (pageData) {
      setCategories(pageData?.Categories || []);
      setAccordionData(pageData?.Accordion || []);
      setProducts(pageData?.ProductsRandomize || []);
      setProduct(pageData?.Product || {});
    }
  }, [pageData]);

  useEffect(() => {
    /*   TABS  - */
    jQuery('#horizontalTab').easyResponsiveTabs({
      type: 'default', //Types: default, vertical, accordion
      width: 'auto', //auto or any width like 600px
      fit: true, // 100% fit in a container
    });
  }, [product]);

  const handlePanelClick = (id: number) => {
    setActivePanel(activePanel === id ? null : id); // Toggle the clicked panel
  };

  return (
    <div>
      {
        product && (
          <Helmet>
            <title>
              {product.title}
            </title>
            <meta name="description" content={product.description} />
          </Helmet>
        )
      }
      {/* Sub Page Content */}
      <div id="sub-page-content" className="clearfix">
        <div className="container">
          <div className="row">
            <div className={product?.is_full_page ? 'col-md-12' : 'col-md-8 clearfix'}>
              <h2 className="bordered light">{product?.title}</h2>
              <div className="row">
                <div className="col-md-6 col-sm-6">
                  <img src={product?.image} alt="" className="img-rounded" />
                </div>
                <div className="col-md-6 col-sm-6">
                  <div className="product-single-content">
                    <h4>{product?.title}</h4>
                    <p>{product?.description}</p>
                    <ul className="medicom-feature-list text-left"
                      style={{
                        display: product?.description_tik1 || product?.description_tik2 ? 'block' : 'none',
                      }}
                    >
                      {Object.keys(product || {}).map((key: string, index: number) => {
                        if (key.includes('description_tik')) {
                          return (
                            <li key={index}>
                              <i className="fa fa-check"></i>
                              {product[key]}
                            </li>
                          );
                        }
                      })}
                    </ul>
                  </div>
                </div>
              </div>

              <div className="height30"></div>

              <h2 className="light bordered">
                {
                  localization?.dict["product_info"].value
                }
              </h2>
              <div id="horizontalTab" className="tab-horizontal1">
                <ul className="resp-tabs-list">
                  <li>{localization?.dict["detail"].value}</li>
                </ul>
                <div className="resp-tabs-container">
                  <div dangerouslySetInnerHTML={{ __html: product?.content || '' }} />

                </div>
              </div>

              {!product?.is_full_page && (
                <>
                  <h2 className="light bordered"
                    dangerouslySetInnerHTML={{
                      __html: pageData?.populated?.ProductsPage?.records
                        ?.find((record: any) => record.title === 'other_products')
                        ?.content
                    }}>
                  </h2>
                  <div className="row">
                    <div className="col-md-12">
                      {products
                        ?.filter((pr: any) => pr.title !== product?.title)
                        .slice(0, 3)
                        .map((product: any, index: any) => (
                          <Product
                            id={product._id}
                            key={index}
                            image={product.image}
                            title={product.title}
                            content={product.content}
                            category={product.category}
                            sef_url={
                              page?.slug?.replace(":cat-slug", product.category.slug).replace(":product-slug", product.sef_url)
                            }
                          />
                        ))}
                    </div>
                  </div>
                </>
              )}
            </div>

            {/* Sidebar */}
            <aside className={product?.is_full_page ? 'hidden' : 'col-md-4'}>
              {/* Categories Widget */}
              <div className="sidebar-widget clearfix">
                <h2 className="light bordered"
                  dangerouslySetInnerHTML={{
                    __html: localization?.dict["categories"]?.value
                  }}>
                </h2>
                <ul className="tags">
                  {categories.map((category: any, index: any) => (
                    <li key={index}>
                      <Link
                        className="link"
                        key={index}
                        to={
                          page?.slug?.replace(":cat-slug", category.slug).replace("/:product-slug", "")
                        }
                      >
                        {category.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="sidebar-widget clearfix">
                <h2 className="light bordered"
                  dangerouslySetInnerHTML={{
                    __html: localization?.dict["general_look"]?.value
                  }}>
                </h2>

                <div className="panel-group" id="accordion">
                  {accordionData?.map((item: any, index: number) => (
                    <AccordionPanel
                      key={index}
                      id={index}
                      title={item.title}
                      content={item.content}
                      isOpen={activePanel === index}
                      onClick={handlePanelClick}
                    />
                  ))}
                </div>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
